let indexIsLoading,
  index_page = [1, 1],
  nsfw = cookie.getcookie("sw") ? Number(cookie.getcookie("sw")) : 0,
  categoryId,
  filtrate,
  gender;
  if(!lang){var lang = 'en'}
  if(!lang_path){var lang_path}
  if(!lang_search){var lang_search}
  // 列出现在存储的语言 判断跳转
  function toLanguages(lang) {
    var _languages = ['en','ja','de','fr','es','pt','ko'];
    for ( var i = 0; i < _languages.length; i++){
      // if (_languages[i] === lang && lang_url_fn() !==lang) {
      if (_languages[i] === lang) {
        localStorage.setItem('lang',lang);
        sessionStorage.setItem('lang',lang);
        // doGTranslate(lang);
        break;
      }
    }
  };
  function lang_url_fn() {
    var lang_url = "en";
    if (window.location.pathname.indexOf("/ja/") > -1) {
      return "ja";
    // }
    // else if (window.location.pathname.indexOf('/zh/')>-1) {
    //     return 'zh';
    // } else if (window.location.pathname.indexOf('/ar/')>-1) {
    //     return 'ar';
    // } else if (window.location.pathname.indexOf('/cs/')>-1) {
    //     return 'cs';
    // } else if (window.location.pathname.indexOf('/da/')>-1) {
    //     return 'da';
    // } else if (window.location.pathname.indexOf('/el/')>-1) {
    //     return 'el';
    } else if (window.location.pathname.indexOf('/es/')>-1) {
        return 'es';
    // } else if (window.location.pathname.indexOf('/fi/')>-1) {
    //     return 'fi';
    // } else if (window.location.pathname.indexOf('/he/')>-1) {
    //     return 'he';
    // } else if (window.location.pathname.indexOf('/hi/')>-1) {
    //     return 'hi';
    // } else if (window.location.pathname.indexOf('/hr/')>-1) {
    //     return 'hr';
    // } else if (window.location.pathname.indexOf('/id/')>-1) {
    //     return 'id';
    // } else if (window.location.pathname.indexOf('/it/')>-1) {
    //     return 'it';
    } else if (window.location.pathname.indexOf('/ko/')>-1) {
        return 'ko';
    // } else if (window.location.pathname.indexOf('/ms/')>-1) {
    //     return 'ms';
    // } else if (window.location.pathname.indexOf('/nb/')>-1) {
    //     return 'nb';
    // } else if (window.location.pathname.indexOf('/nl/')>-1) {
    //     return 'nl';
    // } else if (window.location.pathname.indexOf('/hu/')>-1) {
    //     return 'hu';
    // } else if (window.location.pathname.indexOf('/pl/')>-1) {
    //     return 'pl';
    } else if (window.location.pathname.indexOf('/pt/')>-1) {
        return 'pt';
    // } else if (window.location.pathname.indexOf('/ro/')>-1) {
    //     return 'ro';
    // } else if (window.location.pathname.indexOf('/ru/')>-1) {
    //     return 'ru';
    // } else if (window.location.pathname.indexOf('/sv/')>-1) {
    //     return 'sv';
    // } else if (window.location.pathname.indexOf('/th/')>-1) {
    //     return 'th';
    // } else if (window.location.pathname.indexOf('/tr/')>-1) {
    //     return 'tr';
    // } else if (window.location.pathname.indexOf('/vi/')>-1) {
    //     return 'vi';
    // } else if (window.location.pathname.indexOf('/zh_tw/')>-1) {
    //     return 'zh-Hant';
    } else if (window.location.pathname.indexOf('/ja/')>-1) {
        return 'ja';
    } else if (window.location.pathname.indexOf('/de/')>-1) {
        return 'de';
    } else if (window.location.pathname.indexOf('/fr/')>-1) {
        return 'fr';
    }
    else {
      return "en";
    }
  };
  toLanguages(lang_url_fn());
  function doGTranslate(lang_pair) {
    if(lang_pair.value)lang_pair=lang_pair.value;
    if(lang_pair=='')return;
    var lang=lang_pair;
    var plang=location.pathname.split('/')[1];
    if(plang.length !=2 && plang.toLowerCase() != 'zh-cn' && plang.toLowerCase() != 'zh-tw')plang='en';
    if(lang == 'en')location.href=location.protocol+'//'+location.host+location.pathname.replace('/'+plang+'/', '/')+location.search;else location.href=location.protocol+'//'+location.host+'/'+lang+location.pathname.replace('/'+plang+'/', '/')+location.search;}
  if(window.location.search.indexOf('?test_lang=')>-1) {
    if(!lang){
      lang = window.location.search.split('?test_lang=')[1]
    };
  }else{
    if(localStorage.getItem('lang')){
        lang = localStorage.getItem('lang');
    } else {
        lang = navigator.language;
    };
    toLanguages(lang);
  };
lang_path = lang=='en'?'':'/'+lang;
lang_search = '?lang='+lang;
var isRequestInProgress = false; // 标志变量
let TagClass = ["firstTag", "secondTag", "thirdTag"];
var system_theme = "light-theme";
const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
if (cookie.getcookie("theme") && cookie.getcookie("theme") == "system-theme") {
  if (darkModeMediaQuery.matches) {
    system_theme = "dark-theme";
  } else {
    system_theme = "light-theme";
  }
} else {
  system_theme = cookie.getcookie("theme")
    ? cookie.getcookie("theme")
    : "light-theme";
}
var _path = system_theme == "dark-theme" ? "/dark-theme" : "";
var login_state = (window.login_state = {
  email: "",
  password: "",
  hasaccount: false,
  iSlogin: false,
  iSemail: false,
  iSpassword: false,
  iSverification: false,
  iSsame: false,
  historyList: "",
  hash: [],
  key: [],
  id_token: "",
  e_id: "",
  murmur: "",
  basic_params: "",
  token: "",
  AccessToken: "",
  personal: "",
});
var _url = (window._url = {
  register: "/api/register",
  emaliLogin: "/api/emaliLogin",
  getLoginCode: "/api/getLoginCode",
  codeLogin: "/api/codeLogin",
  emailVerify: "/api/emailVerify",
  getProfile: "api/getProfile",
  googleOauth: "/api/googleOauth",
  getOauthInfo: "/api/getOauthInfo",
  googleLogin: "/api/googleLogin",
  googleRegister: "/api/googleRegister",
  googleConnect: "/api/googleConnect",
  getTagsLists: "/api/getTagsLists",
  getRobotLists: "/api/getRobotLists",
  getRecordLists: "/api/getRecordLists",
  sendRecords: "/api/sendRecords",
  getRobotInfo: "/api/getRobotInfo",
  recordsDel: "/api/recordsDel",
  getRecentLists: "/api/getRecentLists",
  fileUpload: "/api/fileUpload",
  robotAdd: "/api/robotAdd",
  getCategoryLists: "/api/getCategoryLists",
  getPlanLists: "/api/getPlansLists",
  checkout: "/api/checkout",
  getUserplans: "/api/getUserplans",
  getUserInfo: "/api/getUserInfo",
  setUserInfo: "/api/setUserInfo",
  robotEdit: "/api/robotEdit",
  getCollect: "/api/getCollect",
  collectUpdate: "/api/collectUpdate",
  likesUpdate: "/api/likesUpdate",
  followUpdate: "/api/followUpdate",
  chargebeeCheckout: "/api/chargebeeCheckout",
  chargebeeUpgrade: "/api/chargebeeUpgrade",
  updateUserChargebeePlan: "/api/updateUserChargebeePlan",
  getPayUrl: "/api/getPayUrl",
  signIn: "/api/signIn",
  inputInviteCode: "/api/inputInviteCode",
  getScoreEquity: "/api/getScoreEquity",
  scoreExchange: "/api/scoreExchange",
  getScoreEquity: "/api/getScoreEquity",
  getPayMessageList: "/api/getPayMessageList",
  bonusSendMessage: "/api/sendMessage",
  bonusCreateCharacter: "/api/createRoleExchange",
  bonusInviteCode: "/api/inputInviteCode",
  postShareTask: "/api/postShareTask",
  getMoreLists: "/api/getMoreLists",
  getReportLabel: "/api/getReportLabel",
  addReport: "/api/addReport",
  shareTaskStatus: "/api/shareTaskStatus",
  claimShareRewards: "/api/claimShareRewards",
  taskRobotLists: "/api/taskRobotLists",
  threePhotos: "/api/threePhotos",
  viewAllImage: "/api/viewAllImage",
  getNsfw: "/api/getNsfw",
  getPalPayResult: "/api/getPalPayResult",
  getRedDot: "/api/getRedDot",
  getNftLists: "/api/getNftLists",
  updateStatus: "/api/updateStatus",
  searchHistoryList: "/api/searchHistoryList",
  addSearchHistory: "/api/addSearchHistory",
  delSearchHistory: "/api/delSearchHistory",
  hotSearch: "/api/hotSearch",
  rankingList: "/api/rankingList",
  unlockImage: "/api/unlockImage",
  getSocialMedia: "/api/getSocialMedia",
  updateSocialMedia: "/api/updateSocialMedia",
  userScoreReward: "/api/userScoreReward",
  getUserTitle: "/api/getUserTitle",
  receiveTitle: "/api/receiveTitle",
  titleList: "/api/titleList",
  generateImages: "/api/generateImages",
  storyLikesUpdate: "/api/likeChatStory",
  getchatStoryList: "/api/chatStoryList",
  getUserReportLabel: "/api/getUserReportLabel",
  addUserReport: "/api/addUserReport",
  updateReportLevel: "/api/updateReportLevel",
  homeChatStoryList: "/api/homeChatStoryList",
  getStoryLikeStatus: "/api/getStoryLikeStatus",
  getPayConfig: "/api/getPayConfig",
  getPayssionResult: "/api/getPayssionResult",
  useePayCancelSub: "/api/useePayCancelSub",
  followList: "/api/followList",
  fanList: "/api/fanList",
  popularList: "/api/popularList",
  getFollowStatus: "/api/getFollowStatus",
  detailStoryList: "/api/detailStoryList",
  personStoryList: "/api/personStoryList",
  likeStoryList: "/api/likeStoryList",
  getStoryCollectList: "/api/getStoryCollectList",
});
const getOSinfo = () => {
  const userAgent = window.navigator.userAgent;
  let platform = "";
  if (userAgent.indexOf("Win") !== -1) {
    platform = "Windows";
  } else if (userAgent.indexOf("Mac") !== -1) {
    platform = "MacOS";
  } else if (
    userAgent.indexOf("X11") !== -1 ||
    userAgent.indexOf("Linux") !== -1
  ) {
    platform = "Linux";
  }
  const osVersion = userAgent.match(
    /(Windows NT|Mac OS X|Android|iOS)([\d_]+)/
  );
  const version = osVersion ? osVersion[2].replace(/_/g, ".") : "";
  const osInfo = { os: platform, v: version };
  return osInfo;
};
function generateRandomString(length = 32) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}
const getHeaderParams = () => {
  const navigator = window.navigator;
  const { appName, language, userAgent } = navigator;
  const deviceId = userAgent.replace(/[^\w]/gi, "");
  const osInfo = getOSinfo();
  const headers = {
    buildVersion: "1", //构建版本 必传
    deviceId: deviceId, //设备id" 必传
    lang: language, //设备语言 必传
    deviceName: encodeURI(appName), //设备名(urlEncode编码)
    os: osInfo.os, //当前系统
    osVersion: osInfo.v, //当前系统版本号
    platform: "web",
  };
  return headers;
};
login_state.AccessToken = JSON.parse(cookie.getcookie("user"))
  ? JSON.parse(cookie.getcookie("user")).token
  : null;
login_state.basic_params = JSON.stringify(getHeaderParams());
var doman,
  _street = location.hostname,
  host,
  IPToken;
if (location.hostname == "localhost-www.heyreal.ai") {
  doman = "https://sandboxapi67.heyreal.ai";
  host = "localhost-www.heyreal.ai";
  IPToken = "5090de811b668c";
} else if (location.hostname == "sandbox.heyreal.ai") {
  doman = "https://sandboxapi67.heyreal.ai";
  host = "https://sandbox.heyreal.ai/";
  IPToken = "5090de811b668c";
} else if (location.hostname == "pre.heyreal.ai") {
  doman = "https://preapi.heyreal.ai";
  host = "https://pre.heyreal.ai/";
  IPToken = "e823a1713e2497";
} else {
  doman = "https://api.heyreal.ai";
  host = "https://heyreal.ai/";
  IPToken = "e823a1713e2497";
}

//获取浏览器唯一码
var murmur = 1;
var oldmurmur = 1;
try {
  var fpPromise = FingerprintJS.load();
  fpPromise
    .then((fp) => fp.get())
    .then((result) => {
      murmur = result.visitorId;
      oldmurmur = result.visitorId;
      sessionStorage.setItem("murmur", murmur);
      cookie.setcookie("murmur", murmur);
    });
} catch (e) {
  console.log("fingerjs is not defined");
}
// var options = {'excludes': {'userAgent':true,'audio':true,'enumerateDevices':true,'fonts':true,'fontsFlash':true,'canvas':true}}
// try {Fingerprint2.get(options, function (components) {
//   // 参数
//   const values = components.map(function (component) {
//       return component.value;
//   });
//   // 指纹
//   murmur = Fingerprint2.x64hash128(values.join(''), 31);
//   oldmurmur=Fingerprint2.x64hash128(values.join(''), 31);
//   sessionStorage.setItem('murmur',murmur);
//   cookie.setcookie('murmur',murmur);
// });
// } catch(e) {
//   console.log('fingerjs is not defined')
// }
function getAjax(url, opt) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: doman + url,
      type: "POST",
      data: JSON.stringify(opt),
      headers: {
        "Content-Type": "application/json",
        "Access-Token": login_state.AccessToken,
        "Basic-Params": JSON.stringify(getHeaderParams()),
        Traceid: generateRandomString(),
      },
      success: function (response) {
        if (response.code === 20005) {
          handleLoggedOutState();
        } else {
          resolve(response);
        }
      },
      fail: function (error) {
        reject(error);
      },
    });
  });
}
function _getAjax(url, opt) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: doman + url,
      type: "POST",
      data: JSON.stringify(opt),
      headers: {
        "Content-Type": "application/json",
        "Basic-Params": JSON.stringify(getHeaderParams()),
      },
      success: function (response) {
        if (response.code === 20005) {
          handleLoggedOutState();
        } else {
          resolve(response);
        }
      },
      fail: function (error) {
        reject(error);
      },
    });
  });
}
//获取浏览器唯一码
let currentEID = cookie.getcookie("user")
  ? JSON.parse(cookie.getcookie("user")).e_id
  : null;
// $.getScript(host+"js/unique.js",function(){
//   const fpPromise = FingerprintJS.load()
//     fpPromise
//         .then(fp => fp.get())
//         .then(result => {
//           login_state.e_id = result.visitorId
//           if(!currentEID){
//             cookie.setcookie('e_id',result.visitorId,90);
//           }
//             // try{
//             //     murmurAfter()
//             // }catch(error){
//             //
//             // }
//         })
//     });
login_state.e_id = cookie.getcookie("user")
  ? JSON.parse(cookie.getcookie("user")).e_id
  : null;

function handleLoggedOutState() {
  login_state.AccessToken = null;
  cookie.deletecookie("user");
  cookie.deletecookie("userInfoData");
  try {
    cookie.deletecookie("user_google");
  } catch (e) {}
  // 更新前端登录状态
  updateLoginState(false);
  $(".missionContent").length &&
    $(".missionContent .signIn")
      .text(i18n[lang].public_Earn)
      .addClass("allow")
      .removeClass("no");
  $(".missionContent").length &&
    $(".missionContent .exchange")
      .text(i18n[lang].public_Earn)
      .addClass("allow")
      .removeClass("no");
  $(".missionContent").length &&
    $(".missionContent .wordSubmit")
      .text(i18n[lang].public_Submit)
      .addClass("allow")
      .removeClass("no");
  $(".missionContent").length &&
    $(".missionContent .videoSubmit")
      .text(i18n[lang].public_Submit)
      .addClass("allow")
      .removeClass("no");
  $(".metal_zoon").length && $(".metal_zoon").removeClass("hide");
  $(".metal_section").length && $(".metal_section").removeClass("finish");
  $(".icon-menu_bonus").length && $(".icon-menu_bonus").removeClass("active");
  $(".missionContent").length && $(".achievement span").removeClass("active");
  $(".metal_zoon .icon_metal").length &&
    $(".metal_zoon .icon_metal").attr(
      "src",
      "/images/bonus/level-one-black.svg"
    );
  $(".metal_zoon .indeed").length &&
    $(".metal_zoon .indeed").text("0").addClass("allow").removeClass("no");
  $(".metal_zoon .percent").length && $(".metal_zoon .percent").css("width", 0);
  $(".metal_zoon .reward_btn").length &&
    $(".metal_zoon .reward_btn").text(i18n[lang].public_Log_in_to_get).removeClass("tip");
  $("#profileMetalBtn").length &&
    $("#profileMetalBtn").text(i18n[lang].public_Login_for_Achievements);
  $(".profileMetalMask").length &&
    $(".profileMetalMask #profileMetalBtn").text(i18n[lang].public_Login_for_Achievements);
  $(".profileMetalMask").length && $(".profileMetal h2").html("");
  $(".profileMetalMask").length && $(".profile_metal_list").empty();
  $(".profileMetalMask").length && $(".profileMetalInfo").remove();
  $(".missionContent").length &&
    $(".missionContent .metal_tip").removeClass("active");
  $(".header_select_zoon") && $(".header_select_zoon").removeClass("beside");
  $(".language_toggle") && $(".language_toggle").removeClass("beside");
  $(".loginButton").empty();
  $(".loginButton").append(
    `<i class="ivu-icon iconfont icon-user userIcon"></i><span class="signIn">${i18n[lang].log_in}</span>`
  );
  let cardButton = document.querySelectorAll(".card-item .button");
  let token = JSON.parse(cookie.getcookie("user"))
    ? JSON.parse(cookie.getcookie("user")).token
    : null;
  var $content = $(".recentChat .content");
  $content.empty();
  $content.append(`<div class="item2">
          <div class="addChat"><i
              class="ivu-icon iconfont icon-add addIcon"></i>
            <p class="hoverCircle"></p>
          </div>
        </div>`);
  let addChatX, addChatY;
  let isFirstEnter = true;

  $(".addChat")
    .on("mouseenter", function (e) {
      if (isFirstEnter) {
        addChatX = e.offsetX;
        addChatY = e.offsetY;
        $(".hoverCircle").css({
          top: addChatX + "px",
          left: addChatY + "px",
        });
        isFirstEnter = false;
      }
    })
    .on("mouseleave", function () {
      isFirstEnter = true;
    });
  $(".addChat").on("click", function (e) {
    $(".main_section").append(`<div class="loginRequiredMask">
              <div class="loginRequired">
                  <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
                  <div class="title">${i18n[lang].public_Login_Required}</div>
                  <div class="desc">${i18n[lang].public_In_order}</div>
                  <div class="button">${i18n[lang].log_in}</div>
              </div>
          </div>`);
    manage("Popup_Login_View");
    $(".loginRequiredMask").on("click", function () {
      $(".main_section .loginRequiredMask").remove();
    });
    $(".loginRequired").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    $(".loginRequiredMask .button").on("click", function (e) {
      manage("Popup_Login_Click");
      location.href = `${lang_path}/account/login/`;
    });
  });
  cardButton.forEach((i, o) => {
    if (!token) {
      o == 0 || o == 4
        ? (cardButton[o].innerHTML = `Selected`)
        : o == 2 || o == 6
        ? `<img src="/images/account/loading_pur.svg" alt="Loading" width="16" height="16" >${i18n[lang].public_Subscribe}`
        : `<img src="/images/account/loading.svg" alt="Loading" width="16" height="16" >${i18n[lang].public_Subscribe}`;
      o == 0 || o == 4
        ? cardButton[o].classList.replace(
            cardButton[o].classList[1],
            "selected"
          )
        : cardButton[o].classList.replace(
            cardButton[o].classList[1],
            o == 2 || o == 6 ? "subscribe_bla" : "subscribe"
          );
    } else {
      return;
    }
    i.addEventListener("click", (e) => {
      if (!token) {
        $(".main_section").append(`<div class="loginRequiredMask">
                  <div class="loginRequired">
                      <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
                      <div class="title">${i18n[lang].public_Login_Required}</div>
                      <div class="desc">${i18n[lang].public_In_order}</div>
                      <div class="button">${i18n[lang].log_in}</div>
                  </div>
              </div>`);
        manage("Popup_Login_View");
        $(".loginRequiredMask").on("click", function () {
          $(".main_section .loginRequiredMask").remove();
        });
        $(".loginRequired").on("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
        $(".loginRequiredMask .button").on("click", function (e) {
          manage("Popup_Login_Click");
          location.href = `${lang_path}/account/login/`;
        });
        return;
      }
      if (i.getAttribute("data-link") == "null") {
        success(
          i18n[lang].pricing_subscription
        );
        return;
      }
      $('.popMask').show();
      window.open(i.getAttribute("data-link"));
      document.querySelector(".verCancel").addEventListener("click", () => {
        $('.popMask').hide();
      });
      let closeButton = document.querySelectorAll(".close");
      closeButton[0].addEventListener("click", function () {
        $('.popMask').hide();
      });
      document.querySelector(".verPaid").addEventListener("click", () => {
        getAjax(_url.checkout, {
          email: JSON.parse(cookie.getcookie("userInfoData")).email,
          productId: i.getAttribute("data-id"),
        }).then((res) => {
          if (res.code == 200221) {
            addVerifityPop(i);
          } else if (res.code == 7002) {
            error(
              i18n[lang].pricing_Payment_Info_not_detected
            );
          } else if (res.code == 200) {
            $('.popMask').hide();
            let currentUrl = location.href;
            location.href = `${lang_path}/account/profile/?source=` + currentUrl;
          }
        });
      });
    });
  });
  $(".loadingMask").removeClass("show");
  // 解绑事件
  $(document).off("click", ".loginButton");
  $(document).off("click", ".logout");
  // 重新绑定登录按钮事件，重定向到登录页面
  $(".loginButton").removeClass("loginButton_success");
  if ($(".bonusHeader").length) {
    $(".bonusHeader .source").text(0);
    $(".remain_source").text(0);
    $(".bonusHeader .remaining_num").text(0);
    $(".bonusHeader .item_card_num").text(0);
    $(".missionContent .code")
      .text("Invite Code")
      .css("color", "rgb(117,117,117)");
  }
  if (location.pathname == `${lang_path}/pricing/`) {
    $('.card-item .select_zoon .top_item span').html($('.card-item .select_zoon .select_item').eq(0).find('span').html());
    $(".card-item .select_zoon .select_item").each(function (ind, itm) {
      if (ind % 2 == 0) {
        $(itm).addClass("active");
      } else {
        $(itm).removeClass("active");
      }
    });
    $(".select_zoon").show();
  }
  try {
    if (
      cookie.getcookie("recentType1") == "Following" &&
      $(".chatContent.character_zoon") &&
      location.pathname == "/"
    ) {
      $(".chatContent.character_zoon").children().not("#loadBox").remove(),
        $(".chatContent.character_zoon").children("#loadBox").show();
      // if (isRequestInProgress) {
      //     warning(i18n[lang].pricing_character_finish_loading)
      //     return;
      // };
      isRequestInProgress = true;
      $(".classification") && $(".classification .recent .text_normal").text($('#showRencent .item').eq(0).text());
      // 设置标志，表示请求正在进行中
      let keyword = localStorage.getItem("searchText");
      let tempHeight = $(".chatContent.character_zoon").height();
      $(".chatContent.character_zoon").css("height", tempHeight);
      if (try_first) {
        $(".chatContent.character_zoon #loadBox").show();
        try_first = true;
      }
      _getAjax(_url.getRobotLists, {
        categoryId: categoryId,
        nsfw: $(".switchBoxtrue").length > 0 ? nsfw : 0,
        filtrate: 4,
        keyword: localStorage.getItem("searchText"),
        pageNum: 1,
        gender:
          location.pathname == "/search/"
            ? null
            : cookie.getcookie("genderType")
            ? cookie.getcookie("genderType")
            : null,
      }).then((res) => {
        var emptyElement;
        if (res.code == 200) {
          $(".chatContent.character_zoon").children().not("#loadBox").remove();
          $(".tip_follow").remove();
          if (filtrate == 5 && res.is_trend == 1) {
            emptyElement = $(
              `<p class="tip_follow">${i18n[lang].public_no_characters}</p>`
            );
            $(".chatContent.character_zoon").append(emptyElement);
          }
          index_page[0] = 2;
          if (res.data.length >= 1) {
            res.data.forEach((item) => {
              var _openid = "",
                _nickname = "";
              if (item.userProfile && item.userProfile.openid) {
                _openid = item.userProfile.openid;
              }
              if (item.userProfile && item.userProfile.nickname) {
                _nickname = item.userProfile.nickname;
              }
              var _like_num, _chats_num;
              item.like_num
                ? (_like_num = autoNumberTransform(item.like_num))
                : (_like_num = 0);
              item.chats_num
                ? (_chats_num = autoNumberTransform(item.chats_num))
                : (_chats_num = 0);
              $(".main_right .ivu-row.chatContent.character_zoon").append(`
                        <div class="ivu-col ivu-col-span-xs-12 ivu-col-span-sm-12 ivu-col-span-md-8 ivu-col-span-lg-6 ivu-col-span-xl-4 ivu-col-span-xxl-4 itemDiv">
                            <a href="/chat/${item.roleid}" id="robot${
                item.roleid
              }" class="item homeItemInPHP" data-roleid="${item.roleid}"> 
                                <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                    onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                    data-avatar="${
                                      item.avatar_url
                                    }" alt="Character Avatar ${
                item.name
              }" width="" height="">
                                    ${
                                      item.nsfw == 1
                                        ? `<span class="nsfw">Unfiltered</span>`
                                        : item.nsfw == 0
                                        ? `<span class="nsfw sfw">SFW</span>`
                                        : ""
                                    }
                                    <span audit-src="${lang_path}/character/${
                                      item.roleid
                                    }" class="name" id="name${item.roleid}">${
                item.name
              }</span>
                                    <p class="creator">by <span id="profile${
                                      item.roleid
                                    }" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${
                item.userProfile && Boolean(item.userProfile.title)
                  ? '<img class="profile_card" src="' +
                    item.userProfile.title_icon +
                    '" alt="Metal" width="24" height="24" title="' +
                    item.userProfile.title +
                    '" attr-title_id="' +
                    item.userProfile.title_id +
                    '"/>'
                  : ""
              }</p>
                                <p class="desc${
                                  !item.describe || item.describe.length <= 30
                                    ? " notext"
                                    : ""
                                }"
                                title="${
                                  !item.describe || item.describe.length <= 30
                                    ? ""
                                    : escapeHtml(item.describe)
                                }">
                                    ${escapeHtml(item.describe) || ""}
                                </p>
                                <div class="flex-col-between">
                                    ${
                                      item.tagsid &&
                                      JSON.parse(item.tagsid).length > 0
                                        ? `
                                        <ul class="tagsBox">
                                            ${JSON.parse(item.tagsid)
                                              .map(
                                                (inneritem, key) => `
                                                <li class="tagsItem ${
                                                  TagClass[
                                                    key % TagClass.length
                                                  ]
                                                }">
                                                    ${inneritem.name}
                                                </li>
                                            `
                                              )
                                              .join("")}
                                        </ul>
                                    `
                                        : '<div class="tagsBox"></div>'
                                    }
                                        <div class="bottom cen flex_box flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${
                                                  item.is_like ? "active" : ""
                                                }" like-num="${
                item.like_num
              }"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${
                                              item.more_list[2].status == 1
                                                ? `<div id="other_options${item.roleid}" class="other_options other_options${item.roleid}"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>`
                                                : item.more_list[1].status == 1
                                                ? `<div id="other_options${item.roleid}" class="other_options other_options${item.roleid}"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${item.roleid}">${i18n[lang].public_Paid}</span></div>`
                                                : ""
                                            }
                                        </div>
                                </div>
                            </a>
                        </div>
                    `);
              const image = new Image();
              image.src = item.avatar_url;
              image.onload = function () {
                var $img = $(`#robot${item.roleid}`).find(".img");
                if ($img.length) {
                  $img.attr("src", image.src);
                  var oAbc = $img[0].getBoundingClientRect();
                  $(`#robot${item.roleid} .img`).attr({
                    width: oAbc.width,
                    height: oAbc.height,
                  });
                } else {
                  console.error(
                    "Image element not found for roleid:",
                    item.roleid
                  );
                }
              };
              $(".chatContent.character_zoon").css("height", "auto");
              $(`#robot${item.roleid}`).on("click", function (e) {
                e.preventDefault();
                $(".normalLoadToChat").addClass("active");
                localStorage.setItem(
                  "robotInfo",
                  JSON.stringify({
                    name: item.name,
                    tags: item.tagsid ? JSON.parse(item.tagsid) : [],
                    greetings: item.greetings,
                    roleid: item.roleid,
                  })
                );
                redirectToUrl(`/chat/${item.roleid}`);
                setTimeout(() => {
                  $(".normalLoadToChat").removeClass("active");
                }, 2000);
              });
              $(`#name${item.roleid}`).on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                redirectToUrl(`${lang_path}/character/${item.roleid}`);
              });
              $(`#profile${item.roleid}`).on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                redirectToUrl($(this).attr("action-href"));
              });
              $(`.other_options${item.roleid}`).on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                if ($(this).find("i").attr("class").indexOf("active") > -1) {
                  $(this)
                    .find("i")
                    .removeClass("active")
                    .siblings()
                    .removeClass("active");
                } else {
                  $(document).trigger("click");
                  $(this)
                    .find("i")
                    .toggleClass("active")
                    .siblings()
                    .toggleClass("active");
                }
              });
              $(`.other_options${item.roleid} .report`).on(
                "click",
                function (e) {
                  e.stopPropagation();
                  e.preventDefault();
                  $(this).removeClass("active");
                  $(`.other_options${item.roleid}`)
                    .find("i")
                    .removeClass("active");
                  checkLoginStatus(); // 每次点击按钮时先检查登录状态
                  if (!window.isLoggedIn) {
                    login_status();
                  } else {
                    report_arguments(item.roleid, item.name, item.nsfw);
                  }
                }
              );
              $(`.other_options${item.roleid} .character_edit`).on(
                "click",
                function (e) {
                  e.stopPropagation();
                  e.preventDefault();
                  $(this).removeClass("active");
                  $(`.other_options${item.roleid}`)
                    .find("i")
                    .removeClass("active");
                  checkLoginStatus(); // 每次点击按钮时先检查登录状态
                  if (!window.isLoggedIn) {
                    login_status();
                  } else {
                    redirectToUrl($(this).attr("action-href"));
                  }
                }
              );
              $(`#robot${item.roleid} .icon-icon_like2`).on(
                "click",
                function (e) {
                  e.stopPropagation();
                  e.preventDefault();
                  var that = $(this);
                  checkLoginStatus(); // 每次点击按钮时先检查登录状态
                  if (!window.isLoggedIn) {
                    login_status();
                  } else {
                    that.toggleClass("active");
                    var _num = that.attr("like-num");
                    if (that.hasClass("active")) {
                      create_like(
                        item.roleid,
                        item.userProfile.uid,
                        1,
                        _num,
                        that,
                        _creatFlags
                      );
                    } else {
                      create_like(
                        item.roleid,
                        item.userProfile.uid,
                        0,
                        _num,
                        that,
                        _creatFlags
                      );
                    }
                  }
                }
              );
              if ($(`#robot${item.roleid} .profile_card`).length > 0) {
                $(`#robot${item.roleid} .profile_card`).on(
                  "click",
                  function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                    _getAjax(_url.titleList, {
                      uid: item.userProfile.uid,lang:lang
                    }).then((res) => {
                      if (res.code == 200) {
                        $(".profileMetalMask").addClass("active");
                        $(".profileMetal").addClass("active");
                        $(".profileMetal h2").html(
                          item.userProfile.nickname + "'s Achievement(s)"
                        );
                        $(".profile_metal_list").empty();
                        $(".profileMetalInfo").remove();
                        res.data.forEach((item) => {
                          $(".profile_metal_list").append(`
                                        <div class="profile_metal_item" attr-id="${item.id}">
                                            <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                            <p class="title metal_title">${item.title}</p>
                                        </div>
                                        `);
                          $(".profile_metal_container").after(`
                                        <p class="profileMetalInfo">${item.desc}</p>
                                        `);
                        });
                        $(".profile_metal_item").eq(0).addClass("active");
                        $(".profileMetalInfo").eq(0).addClass("active");
                        $("#profileMetalBtn").attr(
                          "attr-id",
                          $(".profile_metal_item").eq(0).attr("attr-id")
                        );
                        if (
                          item.userProfile.uid ==
                          JSON.parse(cookie.getcookie("userInfoData")).uid
                        ) {
                          $("#profileMetalBtn").hide();
                        }
                      } else {
                        error(i18n[lang].public_Failed_Show_Achievements);
                      }
                    });
                  }
                );
              }
            });
          } else {
            emptyElement =
              $(`<div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;">
                <img class="theme-item" src="/images${_path}/index/no_result.svg" width="110" height="110" alt="No Result" style="width: 6.875rem; height: 6.875rem;"/>
                <div style="font-size: 1.125rem; font-weight: bold; max-width: 500px;padding: 0 2rem;text-align: center;margin-top: 2rem;" class="result_info">${i18n[lang].public_results_create}</div>
                <button class="characterButton">${i18n[lang].public_create}</button>
            </div>`);
            $(".chatContent.character_zoon").append(emptyElement);
            if ($(".characterButton").length !== 0) {
              $(".characterButton").click(function (e) {
                e.stopPropagation();
                checkLoginAndRedirect(`${lang_path}/character/create/`);
              });
            }
          }
          var lastPage = res.last_page ? res.last_page : 0;
          addLoad();
          setTimeout(() => {
            $(".chatContent.character_zoon #loadBox").hide();
            isRequestInProgress = storyFirst = false;
            filtrate = 4;
            indexIsLoading = false;
            addTooltip();
            if (index_page[0] > lastPage) {
              _unbindScroll();
            } else {
              _bindScroll();
            }
          }, 1000);
        } else {
          $(".chatContent.character_zoon").children().not("#loadBox").remove();
        }
      });
    }
  } catch (e) {}
  try {
    nologin_handle();
  } catch (e) {}
  if($('.metal_info_section').length){
    $('.metal_info_section .white').eq(0).text('/5000');
    $('.metal_info_section .white').eq(1).text('/5000');
    $('.metal_info_section .white').eq(2).text('/10000');
    $('.metal_info_section .white').eq(3).text('/10000');
    $('.metal_info_section .white').eq(4).text('/100000');
    $('.metal_info_section .white').eq(5).text('/100000');
    $('.metal_info_section .white').eq(6).text('/500000');
    $('.metal_info_section .white').eq(7).text('/500000');
    $('.metal_info_section .white').eq(8).text('/1000000');
    $('.metal_info_section .white').eq(9).text('/1000000');
  }
}
function addLoad() {
  if ($("#loadBox").length === 0) {
    $(".chatContent").append(
      $(
        `<div id="loadBox" style="position: absolute; left: 0; right: 0; top: 0; height: 100%; z-index: 999;background:  ${
          system_theme == "light-theme" ? "#f5f6f9" : "#222"
        };"><div class="loadanimation" style="position: absolute; top: 6.25rem; left: 50%; transform: translateX(-50%);z-index: 100;"></div></div>`
      )
    );
  }
}
// 解除绑定 scroll 事件
function _unbindScroll() {
  if ($(window).width() < 769) {
    $(window).off("scroll", _handleScroll);
  } else {
    $(".layout-content").off("scroll", _handleScroll);
  }
}

// 重新绑定 scroll 事件
function _bindScroll() {
  if ($(window).width() < 769) {
    $(window).on("scroll", _handleScroll);
  } else {
    $(".layout-content").on("scroll", _handleScroll);
  }
}

// 定义 scroll 事件处理函数
function _handleScroll() {
  const scrollTop = $(this).scrollTop();
  const scrollHeight = $(this).prop("scrollHeight")
    ? $(this).prop("scrollHeight")
    : $("html").prop("scrollHeight");
  const clientHeight = $(this).height();
  if (scrollTop + clientHeight >= scrollHeight - 500) {
    _loadMore();
  }
}
function updateLoginState(isLoggedIn) {
  // 更新前端的登录状态，具体实现可以根据你的项目需求来调整
  window.isLoggedIn = isLoggedIn;
}
//手机设备识别
function isIpadOrIphone() {
  const userAgent = navigator.userAgent;
  return /iPad|iPhone/i.test(userAgent);
}
var USER_AGENT = navigator.userAgent;

/**
 * Device is an iPhone
 * @type {Boolean}
 * @constant
 * @private
 */
var IS_IPHONE = /iPhone/i.test(USER_AGENT);
var IS_IPAD = /Mac OS/i.test(USER_AGENT)&&$(window).width()<=1080;
var IS_IPOD = /iPod/i.test(USER_AGENT);
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;

var IOS_VERSION = (function () {
  var match = USER_AGENT.match(/OS (\d+)_/i);
  if (match && match[1]) {
    return match[1];
  }
})();
// languages
var location_h = window.location.href.split('.ai')[1]?window.location.href.split('.ai')[1].split('/')[1]:'en';
// var location_h = '/ja/';
if(location_h!='/'){
  for(var i=0;i<$('.language_toggle li').length;i++){
    if($('.language_toggle li').eq(i).attr('data-value').indexOf(location_h)>-1){
      $('.language_name').text($('.language_toggle li').eq(i).text());
      $('.language_toggle li').eq(i).addClass('active').siblings().removeClass('active');
      break;
    }
  }
};
$(".language_toggle .notranslate").attr('href','https://heyreal.ai/')
$('.language_select .top_language').on('click', function (e) {
    e.stopPropagation();
    $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu');
    $('.drawer-main-mask').hide();
    $('html,body').removeClass('hide');
    $('.language_select').toggleClass('active');
    $('.navigation .header_select').removeClass('active');
});
$('.language_select .languages li').on('click', function (e) {
    e.preventDefault();
    $('.menuIcon').removeClass('icon-menu_close').addClass('icon-menu');
    $('.drawer-main-mask').hide();
    $('html,body').removeClass('hide');
    var now_language = $(this).attr('data-value');
    lang = now_language;
    lang_path = lang=='en'?'':'/'+lang;
    lang_search = '?lang='+lang;
    localStorage.setItem('lang',lang);
    sessionStorage.setItem('lang',lang);
    doGTranslate(now_language);
});

